const STORAGE_KEYS = {
  WORK_ORDERS: "offline_work_orders",
  PROCESS_RECORDS: "offline_process_records",
  PENDING_SYNC: "offline_pending_sync",
} as const;

export interface PendingOperation {
  id: string;
  type: "work_order" | "process_record" | "process_update";
  action: "create" | "update";
  data: any;
  timestamp: number;
}

// Get all pending operations
export function getPendingOperations(): PendingOperation[] {
  try {
    const stored = localStorage.getItem(STORAGE_KEYS.PENDING_SYNC);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
}

// Add a pending operation
export function addPendingOperation(operation: Omit<PendingOperation, "id" | "timestamp">) {
  const operations = getPendingOperations();
  const newOperation: PendingOperation = {
    ...operation,
    id: crypto.randomUUID(),
    timestamp: Date.now(),
  };
  operations.push(newOperation);
  localStorage.setItem(STORAGE_KEYS.PENDING_SYNC, JSON.stringify(operations));
  return newOperation;
}

// Remove a pending operation
export function removePendingOperation(id: string) {
  const operations = getPendingOperations().filter(op => op.id !== id);
  localStorage.setItem(STORAGE_KEYS.PENDING_SYNC, JSON.stringify(operations));
}

// Clear all pending operations
export function clearPendingOperations() {
  localStorage.removeItem(STORAGE_KEYS.PENDING_SYNC);
}

// Work Orders offline storage
export function getOfflineWorkOrders() {
  try {
    const stored = localStorage.getItem(STORAGE_KEYS.WORK_ORDERS);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
}

export function saveOfflineWorkOrders(workOrders: any[]) {
  localStorage.setItem(STORAGE_KEYS.WORK_ORDERS, JSON.stringify(workOrders));
}

// Process Records offline storage
export function getOfflineProcessRecords() {
  try {
    const stored = localStorage.getItem(STORAGE_KEYS.PROCESS_RECORDS);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
}

export function saveOfflineProcessRecords(records: any[]) {
  localStorage.setItem(STORAGE_KEYS.PROCESS_RECORDS, JSON.stringify(records));
}
